import { useToast } from '@cad-arc';
import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';
import { useReleaseBackupUnitsApi } from '../unit-context-menu/use-release-backup-units-api';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { createApiErrorHandler } from '@m43/core';

export function ReleaseBackupItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const releaseBackupUnits = useReleaseBackupUnitsApi();
    const toast = useToast();
    return (
        <ContextMenuItem
            dataTrackId="menu-item-release-backup"
            contextMenuItemView={contextMenuItemView}
            onSelect={() =>
                releaseBackupUnits(clickParams.eventId).catch(
                    createApiErrorHandler(() => {
                        toast({
                            status: 'error',
                            description: errorOccurredWhile('releasing backup units'),
                        });
                    })
                )
            }
        />
    );
}
